<div class="idp-card d-flex flex-column mb-3 mx-3">
    <div class="idp-card-header w-100 px-3 my-4">
        <h2 class="m-0">{{ detail.title }}</h2>
    </div>
    <div class="idp-card-body mx-3 mb-3 p-3">
        <div class="d-flex justify-content-between">
            <span>{{ detail.total.name }}</span>
            <span>{{ detail.total.value | currency: 'USD' : 'symbol' }}</span>
        </div>
        <hr />
        <table style="width: 100%">
            @for (item of detail.details; track item) {
                <tr>
                    <td>{{ item.name }}</td>
                    <td style="text-align: right">
                        @if (item.type === 'string') {
                            <span>{{ item.value }}</span>
                        }
                        @if (item.type === 'currency') {
                            <span>{{ item.value | currency: 'USD' : 'symbol' }}</span>
                        }
                        @if (item.type === 'date') {
                            <span>{{ item.value | weissmanDateFormat: true }}</span>
                        }
                    </td>
                    @if (isCheckboxesEnabled && !isBill) {
                        <td style="text-align: right">
                            <div class="checkbox" [class.invisible]="!item.value" style="margin: 0">
                                <label>
                                    <input
                                        type="checkbox"
                                        style="margin-top: 6px"
                                        [disabled]="disableApplyAll"
                                        [(ngModel)]="item.apply"
                                    />
                                </label>
                            </div>
                        </td>
                    }
                </tr>
            }
        </table>
    </div>
</div>
